<script>
  // @ts-check

  import { getTheme } from "../utilities/themes";

  import DynamicHeading from "../atoms/DynamicHeading.svelte";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /**
   * The title of the hero section
   * @type {string}
   */
  export let title;

  /**
   * The subtitle of the hero section
   * @type {string}
   */
  export let subtitle = null;

  /**
   * The call to action in the hero section
   * @type {import('../types/shared.js').CTA}
   */
  export let cta;

  /**
   * The background image for the hero section
   * @type {import('../types/shared.js').Image}
   */
  export let featuredImage;

  /**
   * The theme of the hero section
   * @type {import('../utilities/themes.js').ThemeName}
   */
  export let theme = "white";

  $: currentTheme = getTheme(theme);

  let backgroundImageClass = `bg-cover bg-center bg-no-repeat`;

  // This containerTopMarginClass is to make sure that the background image is not hidden behind the navigation bar.
  let containerTopMarginClass = "mt-[var(--nav-height)]";

  // This containerHeightClass is to make sure that the hero section is at most the height of the viewport minus the height of the navigation bar, ensureing that CTA is always visible above the fold.
  let containerHeightClass = "max-h-[calc(100vh-var(--nav-height))]";

  let textClass = "break-words w-full md:w-[40%]";
</script>

<div
  {id}
  class="flex flex-col gap-y-4 px-7.5 lg:px-15 {currentTheme?.textColor} {backgroundImageClass} {containerHeightClass} {containerTopMarginClass} "
  style={`background-image: url("${featuredImage.src}")`}
>
  <DynamicHeading aria-label={title} class="heading-md mt-[5%] {textClass}">
    {title}
  </DynamicHeading>
  {#if subtitle}
    <div class="subtitle body-sm flex-1 {textClass}">
      {subtitle}
    </div>
  {/if}
  <!-- This slot is used for storybook purpose only to place a FRU component  -->
  <slot name="donateComponent">
    {#if cta?.htmlSnippet}
      <div
        class="-mx-9.5 -mb-2 h-[var(--embed-height)] sm:-mx-2 sm:mb-[5%]"
        data-chromatic="ignore"
      >
        <!--eslint-disable-next-line svelte/no-at-html-tags -->
        {@html cta.htmlSnippet}
      </div>
    {/if}
  </slot>
</div>
